module.exports = __webpack_public_path__ + "img/arrow-up.03946249.svg";